// extracted by mini-css-extract-plugin
export default {"m":"jQvax5vO6A_landings","l":"IUFfvUvLkZ_landings"};